import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  height: 6.250em;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./client/components/HomePage/About/SponsorLogos/SponsorLogo/Wrapper.js